import { render, staticRenderFns } from "./index.vue?vue&type=template&id=12bbb9cc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=12bbb9cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bbb9cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12bbb9cc')) {
      api.createRecord('12bbb9cc', component.options)
    } else {
      api.reload('12bbb9cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=12bbb9cc&scoped=true&", function () {
      api.rerender('12bbb9cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/city-dynamic-data/index.vue"
export default component.exports